// 首页与导航：简体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 移动首页
export const mobile = Object.freeze({
  "mobile.category.all": "全部分类",
  "mobile.category.searchPlaceholder": "请输入搜索关键词",
  "mobile.home.bulkUploadTitle": "批量上传供需信息",
  "mobile.home.bulkUploadHint": "支持 XLS、XLSX 文件，每次上传一个文件",
  "mobile.home.uploadAction": "点击上传",
  "mobile.home.cancel": "取消",
  "mobile.home.confirm": "确定",
  "mobile.home.bannerAlt": "首页 Banner",
  "mobile.home.serviceValues": "先搜服务价值",
  "mobile.home.excellentService": "卓越服务",
  "mobile.home.continuousInnovation": "持续创造",
  "mobile.home.winTogether": "协作共赢",
  "mobile.home.sharedValue": "价值共享",
  "mobile.home.content": "首页内容",
  "mobile.home.feedTabs": "首页信息分类",
  "mobile.home.viewMode": "商品展示方式",
  "mobile.home.twoColumns": "双列模式",
  "mobile.home.listMode": "列表模式",
  "mobile.home.listEnd": "我们是有底线的",
  "mobile.home.loadFailedReload": "获取数据失败，请重新加载",
  "mobile.home.noProducts": "暂无可展示的商品",
  "mobile.home.filterClues": "筛选供需信息",
  "mobile.home.filterSelectedCount": "筛选供需信息，已选{count}项",
  "mobile.home.clueSearchPlaceholder": "搜索品牌、料号、类型或供应商",
  "mobile.home.clearSearch": "清除搜索关键词",
  "mobile.home.searchClues": "搜索供需信息",
  "mobile.home.import": "导入",
  "mobile.home.filter": "筛选",
  "mobile.home.closeFilter": "关闭筛选",
  "mobile.home.sourceRegion": "货源地",
  "mobile.home.brand": "品牌",
  "mobile.home.brandInitial": "品",
  "mobile.home.collapse": "收起",
  "mobile.home.expand": "展开",
  "mobile.home.reset": "重置",
  "mobile.home.viewResults": "查看结果",
  "mobile.home.clear": "清除",
  "mobile.home.loadFailedRetry": "获取数据失败，请重试",
  "mobile.home.reload": "重新加载",
  "mobile.home.type": "类型",
  "mobile.home.capacity": "容量",
  "mobile.home.architecture": "架构",
  "mobile.home.speed": "速率",
  "mobile.home.ballCount": "球位",
  "mobile.home.quantity": "数量",
  "mobile.home.unitPrice": "单价",
  "mobile.home.priceOnRequest": "价格面议",
  "mobile.home.noPartNumber": "无料号",
  "mobile.home.batch": "批次",
  "mobile.home.stockLocation": "货所在地",
  "mobile.home.supplier": "供应商",
  "mobile.home.publishedAt": "发布时间",
  "mobile.home.noClues": "暂无信息",
  "mobile.home.itemsSelected": "项已选择",
  "mobile.home.delete": "删除",
  "mobile.home.review": "审核",
  "mobile.home.all": "全部",
  "mobile.home.mainland": "大陆",
  "mobile.home.hongKongMacaoTaiwan": "港澳台",
  "mobile.home.allBrands": "全部品牌",
  "mobile.home.keyword": "关键词",
  "mobile.home.tradeInfo": "成交信息",
  "mobile.home.clueInfo": "供需商机",
  "mobile.home.newOrder": "您有新订单!",
  "mobile.home.acceptOrder": "去接单",
  "mobile.home.uploading": "上传中...",
  "mobile.home.uploadSucceeded": "上传成功",
  "mobile.home.uploadFailed": "上传失败",
  "mobile.home.selectUploadFile": "请选择要上传的文件",
  "mobile.home.waitForUpload": "文件上传中，请等待上传完成",
  "mobile.home.importSucceeded": "导入成功",
  "mobile.home.importFailed": "导入失败",
  "mobile.home.importFailedRetry": "导入失败，请稍后重试",
  "mobile.home.confirmDeletion": "删除确认",
  "mobile.home.deleteSelectedConfirm": "是否删除这{count}条数据？",
  "mobile.home.deleteSucceeded": "删除成功",
  "mobile.home.deleteFailedRetry": "删除失败，请稍后重试",
  "mobile.home.confirmReview": "审核确认",
  "mobile.home.reviewSelectedConfirm": "是否审核这{count}条数据？",
  "mobile.home.reviewSucceeded": "审核成功",
});

// 测试商城首页
export const testHome = Object.freeze({
  "pcCsHome.products": "商品",
  "pcCsHome.information": "信息",
  "pcCsHome.imageView": "图片视图",
  "pcCsHome.tableView": "表格视图",
  "pcCsHome.brandPlaceholder": "请输入品牌",
  "pcCsHome.partNumberPlaceholder": "请输入料号",
  "pcCsHome.origin": "货源地",
  "pcCsHome.originPlaceholder": "请选择货源地",
  "pcCsHome.supplierPlaceholder": "请输入供应商",
  "pcCsHome.productType": "产品类型",
  "pcCsHome.productTypePlaceholder": "请输入产品类型/容量/架构/速率/球位",
});

// 页脚
export const footer = Object.freeze({
  "pcFooter.logo": "先搜标志",
  "pcFooter.email": "电子邮箱",
  "pcFooter.phone": "电话",
  "pcFooter.wechat": "微信",
  "pcFooter.weibo": "微博",
  "pcFooter.taobao": "淘宝",
  "pcFooter.copyright":
    "Copyright © 2017-2026 先搜科技 (https://www.xsou.com) All Rights Reserved.",
  "pcFooter.company": "先搜科技",
  "pcFooter.about": "关于先搜",
  "pcFooter.contact": "联系我们",
  "pcFooter.join": "加入我们",
  "pcFooter.privacy": "隐私说明",
  "pcFooter.help": "帮助中心",
  "pcFooter.services": "先搜服务",
  "pcFooter.supplierJoin": "供应商入驻",
  "pcFooter.supplyChainManagement": "供应链管理",
  "pcFooter.supplyChainServices": "供应链服务",
  "pcFooter.supplyChainFinance": "供应链金融",
  "pcFooter.products": "产品介绍",
  "pcFooter.flash": "闪存",
  "pcFooter.memory": "内存",
  "pcFooter.embedded": "嵌入式存储器",
  "pcFooter.ssd": "固态硬盘",
  "pcFooter.memoryModule": "内存条",
  "pcFooter.usbFlashCard": "USB闪存卡",
  "pcFooter.gpuServer": "GPU服务器",
  "pcFooter.chipNetwork": "先搜芯链",
  "pcFooter.ai": "先搜AI",
  "pcFooter.featuredChips": "芯片精选",
  "pcFooter.bidding": "芯片竞价",
  "pcFooter.supplyDemand": "供需信息",
  "pcFooter.directSales": "芯片自营",
  "pcFooter.wiki": "芯片百科",
  "pcFooter.marketIndex": "价格指数",
  "pcFooter.tools": "工具",
  "pcFooter.ascTool": "ASC工具",
  "pcFooter.xmlTool": "XML工具",
});

// 桌面首页
export const desktop = Object.freeze({
  "pcHome.groupedViewDetail": "查看详情",
  "pcHome.operation": "操作",
  "pcHome.goReview": "去审核",
  "pcHome.technicalParameters": "技术参数",
  "pcHome.productSpecifications": "产品规格",
  "pcHome.quantityBatch": "数量 / 批次",
  "pcHome.publishInfo": "发布信息",
  "pcHome.scrollTableLeft": "向左滚动列表",
  "pcHome.scrollTableRight": "向右滚动列表",
  "pcHome.tableHorizontalScroll": "列表横向滚动条",
  "pcHome.selectLoadedClues": "全选当前已加载的信息",
  "pcHome.contactPublisher": "联系发布人 {name}",
  "pcHome.publisherConsultationFailed": "发布人咨询暂时无法打开，请重试",
  "pcHome.marketNav": "行情",
  "pcHome.brandFallback": "品牌{number}",
  "pcHome.sortName": "名称",
  "pcHome.sortProducts": "产品数",
  "pcHome.sortPopularity": "热度",
  "pcHome.bulkUploadTitle": "批量上传供需信息",
  "pcHome.bulkUploadDescription": "请上传 Excel 文件，支持 .xlsx、.xls 格式",
  "pcHome.chooseFile": "点击上传文件",
  "pcHome.cancel": "取消",
  "pcHome.confirm": "确定",
  "pcHome.confirmUpload": "确定上传",
  "pcHome.searchPlaceholder": "搜索料号、名称",
  "pcHome.searchAction": "先搜一下",
  "pcHome.serviceValues": "先搜服务价值",
  "pcHome.excellentService": "卓越服务",
  "pcHome.continuousInnovation": "持续创造",
  "pcHome.winWinCooperation": "协作共赢",
  "pcHome.sharedValue": "价值共享",
  "pcHome.ai": "先搜AI",
  "pcHome.popularBrands": "热门品牌",
  "pcHome.moreBrands": "查看更多品牌",
  "pcHome.brandsLoading": "品牌加载中...",
  "pcHome.noBrands": "暂无品牌数据",
  "pcHome.scrollShortcutsLeft": "向左滑动快捷入口",
  "pcHome.scrollShortcutsRight": "向右滑动快捷入口",
  "pcHome.shortcutIcon": "图标",
  "pcHome.backToTop": "回到顶部",
  "pcHome.shortcut.supplyDemand": "供需",
  "pcHome.shortcut.supply": "供应",
  "pcHome.shortcut.demand": "需求",
  "pcHome.shortcut.selfOperated": "自营",
  "pcHome.shortcut.featured": "精选",
  "pcHome.shortcut.bidding": "竞标",
  "pcHome.shortcut.wiki": "芯片百科",
  "pcHome.shortcut.marketIndex": "价格指数",
  "pcHome.shortcut.traceability": "检测溯源",
  "pcHome.shortcut.training": "培训认证",
  "pcHome.shortcut.brands": "品牌",
  "pcHome.importSupplyDemand": "导入供需",
  "pcHome.gridView": "图片",
  "pcHome.cardView": "卡片",
  "pcHome.listView": "列表",
  "pcHome.endOfList": "我们是有底线的",
  "pcHome.loadFailedRetry": "获取数据失败，请重新加载",
  "pcHome.image": "图片",
  "pcHome.productImage": "商品图片",
  "pcHome.brand": "品牌",
  "pcHome.brandInitial": "品",
  "pcHome.partNumber": "料号",
  "pcHome.noPartNumber": "无料号",
  "pcHome.type": "类型",
  "pcHome.capacity": "容量",
  "pcHome.architecture": "架构",
  "pcHome.speed": "速率",
  "pcHome.ballCount": "球位",
  "pcHome.price": "价格",
  "pcHome.unitPrice": "单价",
  "pcHome.quantity": "数量",
  "pcHome.publisher": "发布人",
  "pcHome.noData": "暂无数据",
  "pcHome.filters": "筛选条件",
  "pcHome.brandLabel": "品牌：",
  "pcHome.all": "全部",
  "pcHome.search": "搜索",
  "pcHome.originLabel": "货源地：",
  "pcHome.mainland": "大陆",
  "pcHome.hongKongMacaoTaiwan": "港澳台",
  "pcHome.keywordLabel": "关键词：",
  "pcHome.filterPlaceholder":
    "搜索品牌、料号、产品类型、容量、架构、速率、球位、供应商或发布人",
  "pcHome.reset": "重置",
  "pcHome.query": "查询",
  "pcHome.loading": "加载中...",
  "pcHome.loadFailedRefresh": "获取数据失败，请刷新重试",
  "pcHome.reload": "重新加载",
  "pcHome.batch": "批次",
  "pcHome.goodsLocation": "货所在地",
  "pcHome.publishedAt": "发布时间",
  "pcHome.supplier": "供应商",
  "pcHome.selectedCount": "已选择 {count} 项",
  "pcHome.delete": "删除",
  "pcHome.review": "审核",
  "pcHome.searchBrand": "搜索品牌",
  "pcHome.brandNamePlaceholder": "请输入品牌名称",
  "pcHome.searching": "搜索中...",
  "pcHome.noMatchingBrands": "未找到匹配的品牌",
  "pcHome.informationSaved": "保存成功，待审核",
  "pcHome.information": "资讯信息",
  "mobile.home.information": "资讯信息",
  "pcHome.tradeInfo": "成交信息",
  "pcHome.supplyDemandInfo": "供需商机",
  "pcHome.newMessages": "您有新消息!",
  "pcHome.viewMessages": "去查看",
  "pcHome.newOrders": "您有新订单!",
  "pcHome.acceptOrder": "去接单",
  "pcHome.uploading": "上传中...",
  "pcHome.uploadSuccess": "上传成功",
  "pcHome.uploadFailed": "上传失败",
  "pcHome.chooseFileFirst": "请选择要上传的文件",
  "pcHome.waitForUpload": "文件上传中，请等待上传完成",
  "pcHome.importSuccess": "导入成功",
  "pcHome.importFailed": "导入失败",
  "pcHome.deleteConfirmTitle": "删除确认",
  "pcHome.deleteConfirmMessage": "是否删除这{count}条数据？",
  "pcHome.deleteSuccess": "删除成功",
  "pcHome.deleteFailed": "删除失败，请稍后重试",
  "pcHome.reviewConfirmTitle": "审核确认",
  "pcHome.reviewConfirmMessage": "是否审核这{count}条数据？",
  "pcHome.reviewSuccess": "审核成功",
});

export const messages = Object.freeze({
  ...mobile,
  ...testHome,
  ...footer,
  ...desktop,
});
